export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 right-0 w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute bottom-0 left-10 w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>免费 · 全集 · 离线缓存</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              番茄漫画
              <span className="block text-xl md:text-2xl lg:text-3xl text-foreground-600 font-sans font-light mt-2">
                下拉式竖屏滚动，畅读海量漫画
              </span>
            </h1>

            <p className="text-foreground-500 text-base md:text-lg leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              随时随地，沉浸式阅读体验。覆盖韩漫、日漫、国漫三大品类，支持下拉式竖屏连续滚动阅读，
              告别翻页打断，让每一话都行云流水。无论热门连载还是经典完结，全部免费畅读，
              离线缓存功能让你在地铁、旅途也能不间断追更。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <strong className="text-foreground-800">日更 1000+ 话</strong>
                <span className="text-foreground-400">新鲜不断</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                <strong className="text-foreground-800">韩漫·日漫·国漫</strong>
                <span className="text-foreground-400">全覆盖</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                <strong className="text-foreground-800">千万读者</strong>
                <span className="text-foreground-400">信赖之选</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始阅读
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-foreground-200 text-foreground-700 rounded-full text-base font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-line text-lg"></i>
                下载 APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] md:w-[340px] md:h-[460px] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20anime%20manga%20illustration%20with%20dynamic%20character%20poses%20in%20warm%20vibrant%20colors%2C%20comic%20reading%20atmosphere%2C%20vertical%20scrolling%20composition%2C%20clean%20minimal%20background%20with%20soft%20gradient%20in%20coral%20and%20cream%20tones%2C%20modern%20webtoon%20aesthetic%2C%20editorial%20quality%2C%20no%20text%20overlay&width=680&height=920&seq=hero-manga-visual-01&orientation=portrait"
                alt="番茄漫画 - 下拉式竖屏漫画阅读体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}